// extracted by mini-css-extract-plugin
export default {"selectContainer":"SwitchButton_selectContainer__hF8Ro","active":"SwitchButton_active__NNZ1c","switch-button":"SwitchButton_switch-button__iQHTB"};